export function getToken() {
  return localStorage.getItem(`token`);
}

export function setToken(token) {
  localStorage.setItem(`token`, token);
}

export const requestHeaders = (token) => ({
  headers: {
    Authorization: 'Bearer ' + token,
  },
});
